import { getAuthAxiosBackend } from "../../helpers/axios"

class ProjectServices{

    getStatuses(){
        return getAuthAxiosBackend().get('booths/statuses')
    }

    get(id){
        return getAuthAxiosBackend().get('booths/booths/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('booths/booths', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('booths/booths/' + id)
    }

    updateStatus(data = {}){
        return getAuthAxiosBackend().put('booths/booths/' + data.id.toString(), data)
    }
}

export default new ProjectServices()